import logo from "../images/logo.svg";

export default {
  adminHeaderBorderBottomColor: "#C6C6C6",
  admin_pie_chart_color_primary: "#296469",
  admin_pie_chart_color_secondary: "#DBE247",
  admin_pie_chart_color_tertiary: "#03494E",
  admin_pie_chart_color_rest: "#749B9E",
  advisor_page_dashboard_active_tab_color: "#DBE247",
  advisor_page_dashboard_right_side_section_background: "#749b9e",
  advisor_page_dashboard_right_side_section_title_color: "#ffffff",
  advisor_page_dashboard_right_side_section_title_copy: "Market News & Updates",
  color_admin_analytic_value: "#131523",
  button_primary_background: "#428A16",
  colorPrimary: "#215054",
  color_tertiary_button: "#1B5568",
  quarterly_goal_aum_color: "#DBE247",
  quarterly_goal_client_color: "#4F8083",
  quarterly_goal_proposal_color: "#749B9E",
  logo_src: logo,
  radio_button_color: "#4F8083",
  sidebar_avatar_background: "#6DC1C7",
  sidebar_avatar_color: "#FFFFFF",
  sidebar_background: "#03494E",
  sidebar_icon_color: "#9AB6B8",
  sidebar_menu_item_hover_background: "#052D2C",
  top_products_pie_chart_pallet: ["#296469", "#DBE247", "#03494E", "#749B9E"],
};
